//-------------------------------------------------------------------------
// Temporary custom button pending proper re-factoring of application theme
//-------------------------------------------------------------------------

// TODO: Move these styling changes to a global theme override (affecting
//       MuiButton) so that the standard Button class will be properly
//       themed with Nuvoola's theme.
// TODO: Once the above is done:
//       - Replace all instances of NuvButton with Button.
//       - Delete this file.

import { withStyles } from "@material-ui/styles";
import Button from '@material-ui/core/Button';

const NuvButton = withStyles((theme) => ({
    root: {
      color: "#0096a7",
    },
    iconSizeMedium: {
      '& *': {
        '&:first-child': {
          fontSize: 24
        }
      }
    }
  }))(Button);
  
export default NuvButton;